import { FC } from 'react';
import classNames from 'classnames';
import Link from 'next/link';
import { PrismicRichText } from '@prismicio/react';
import {
  BlogPostsSlice3ColumnsItem,
  BlogPostsSlice3ColumnsPrimary,
} from '@/types';
import { BlogFigureImage } from '../Blog.components';

import style from '../blog.module.scss';

const HeadingVariation: FC<Props> = ({ items, primary }) => {
  return (
    <>
      <PrismicRichText field={primary?.section_title} />
      <div
        className={classNames(
          style.blogs__articles,
          style.blogs__articles_column_heading,
        )}
      >
        {items.map((item, index) => {
          const { title, description, link, image } = item;

          return (
            <article key={`heading-${index}`}>
              <Link
                className={classNames(style.article, style.article_heading)}
                href={link || ''}
              >
                <BlogFigureImage image={image} />
                <blockquote>
                  <PrismicRichText field={title} />
                  <PrismicRichText field={description} />
                </blockquote>
              </Link>
            </article>
          );
        })}
      </div>
    </>
  );
};

interface Props {
  primary: BlogPostsSlice3ColumnsPrimary;
  items: BlogPostsSlice3ColumnsItem[];
}

export default HeadingVariation;
